/* eslint-disable react-hooks/rules-of-hooks */

import React from 'react'
import debounce from 'lodash/debounce'

/**
 * Create a debounced handler over a provided one
 * @param {Function} callback - callback to be debounced
 * @param {Number} timeout - number of milliseconds used to debounce the callback
 * @param {Object} options - options for the lodash debounce method
 */
const useHandlerDebounced = (timeout, options = {}) => callback => {
  // create ref
  const ref = React.useRef()

  // update ref with new callback each time
  ref.current = callback

  // create the debounced callback with the callback inside ref
  const debounced = React.useMemo(
    () => debounce((...args) => ref.current.apply(this, args), timeout, options),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [timeout, ...Object.values(options)]
  )

  // cancel the debounce when it changes
  React.useEffect(() => () => debounced.cancel(), [debounced])

  // return the debounced callback
  return debounced
}

export default useHandlerDebounced
